import { PeoplePicker, PersonType } from "@microsoft/mgt-react";
import { isEqual } from "lodash";
import { Dispatch, FC, Fragment, useCallback, useMemo } from "react";
import { approverType } from "../../../../../../constants/itCodeRequestConstants";
import { useSelector } from "../../../../../../store/store";
import InformationList, { ColumnContent, LeftRightContent, ListContent } from "../../../../components/InformationList";
import TableModal from "../../../../components/detail";
import { useProcess } from "../../../../process-context";
import { FileAttachmentCard } from "../../../../upload";
import CommentSection from "../../../commentsection/comment-sections";
import { tableColumns } from "./table-column";

interface Props {
  setAssignList: Dispatch<any>;
}

const FormContent: FC<Props> = (props) => {
  const { setAssignList } = props;

  const { Request, approvalStep, approvalType, comment, setComment } = useProcess();

  const { fields } = Request;
  const user = useSelector((state) => state.user);

  const onEmployeeChange = useCallback(
    (selectedOptions: any) => {
      const assignedList = selectedOptions?.target?.selectedPeople;
      setAssignList(assignedList);
    },
    [setAssignList],
  );

  const comments = useMemo(() => {
    const {
      eDeptHeadComment,
      eITLeadComment,
      // eITHeadComment,
      eAssigneeComment,
      eApprovedBy,
      eApprovedByITLead,
      // eApprovedByITHead,
      eAssignee,
    } = fields;

    return [
      {
        hidden: !eDeptHeadComment,
        content: `Lưu ý của ${eApprovedBy.split("|")[1]}: ${eDeptHeadComment}`,
      },
      {
        hidden: !eITLeadComment,
        content: `Lưu ý của ${eApprovedByITLead.split("|")[1]}: ${eITLeadComment}`,
      },
      // {
      //   hidden: !eITHeadComment,
      //   content: `Lưu ý của ${eApprovedByITHead.split("|")[1]}: ${eITHeadComment}`,
      // },
      {
        hidden: !eAssigneeComment,
        content: `Lưu ý của ${eAssignee.split("|")[1]}: ${eAssigneeComment}`,
      },
      {
        hidden: approvalStep !== approvalType,
        content: (
          <div className="input">
            <textarea
              id="account-delete-granted"
              value={comment}
              placeholder="Nhập lưu ý..."
              onChange={(e) => setComment(e.target.value)}
            />
          </div>
        ),
      },
    ];
  }, [fields, approvalStep, approvalType, comment, setComment]);

  const smColData = useMemo(() => {
    return [
      {
        content: (
          <LeftRightContent left="Người yêu cầu:" right={<strong>{Request.createdBy.user.displayName}</strong>} />
        ),
      },
      {
        content: (
          <LeftRightContent
            left="SĐT Người yêu cầu:"
            right={<strong>{Request.fields.ePhoneNumber}</strong>}
            smColumn={false}
          />
        ),
      },
      {
        content: <LeftRightContent left="Cơ quan/Đơn vị:" right={<strong>{Request.fields.eDepartment}</strong>} />,
      },
      {
        hidden: {
          sm: isEqual(Request.fields.eDepartment, Request.fields.eUnit),
        },
        content: <LeftRightContent left="Đơn vị:" right={<strong>{Request.fields.eUnit}</strong>} />,
      },
      {
        hidden: {
          sm: isEqual(Request.fields.eDepartment, Request.fields.eUnion),
        },
        content: <LeftRightContent left="Đội/Tổ:" right={<strong>{Request.fields.eUnion}</strong>} />,
      },
      {
        content: <LeftRightContent left="Mô tả:" right={Request.fields.eDescription} />,
      },
    ];
  }, [Request]);

  const fullColData = useMemo(() => {
    return [
      {
        content: <TableModal data={JSON.parse(Request.fields.eContent)} columns={tableColumns} />,
      },
      {
        content: (
          <Fragment>
            Tệp đính kèm
            <div className="mt-2 d-flex flex-column">
              <FileAttachmentCard
                listFile={Request.fields.eFileContent ? JSON.parse(Request.fields.eFileContent) : []}
              />
            </div>
          </Fragment>
        ),
      },
      {
        content: (
          <Fragment>
            Thông tin trao đổi
            <div className="mt-2">
              <CommentSection comments={[]} data={Request} user={user} id={4} className="mb-4" />
            </div>
          </Fragment>
        ),
      },
      {
        hidden: approvalType !== approverType.itlead || approvalStep !== approvalType,
        content: (
          <ColumnContent
            label="Cán bộ hoàn tất nghiệm thu"
            content={
              <div className="people_picker-custom-detail">
                <PeoplePicker
                  className="people-picker"
                  placeholder="Vui lòng chọn cán bộ hoàn tất nghiệm thu"
                  type={PersonType.any}
                  selectionChanged={onEmployeeChange}
                />
              </div>
            }
          />
        ),
      },
      {
        content: (
          <ListContent
            label="Lưu ý"
            data={comments}
            getItemHidden={(item) => item.hidden}
            renderItemContent={(item) => item.content}
          />
        ),
      },
    ];
  }, [Request, comments, user, approvalType, approvalStep, onEmployeeChange]);

  return (
    <Fragment>
      <InformationList
        size="sm-col"
        data={smColData}
        renderContent={(item) => item.content}
        getItemHidden={(item) => item.hidden}
      />
      <InformationList
        size="full-col"
        data={fullColData}
        getItemHidden={(item) => item.hidden}
        renderContent={(item) => item.content}
      />
    </Fragment>
  );
};

export default FormContent;
